import { useSuspenseQuery } from "@tanstack/react-query";
import { useParams } from "@tanstack/react-router";
import { parseLang } from "@majourneys/shared";
import { blogApi } from "../api/blog.api";
import { blogKeys } from "../constants/query-keys";

export function useBlog(slug: string) {
  const { lang } = useParams({ strict: false }) as { lang?: string };
  const l = parseLang(lang);
  return useSuspenseQuery({
    queryKey: blogKeys.detail(l, slug),
    queryFn: () => blogApi.getBySlug(slug, l),
  });
}
